/**
 * Roketfy reviews widget'ının scroll'unu düzenleyen ve mobilde kaldıran script.
*/
(function () {
  const SCROLL_DURATION = 1200;
  const MOBILE_BREAKPOINT = 768;

  document.addEventListener(
    'click',
    function (e) {
      const widget = e.target.closest('.widget-style-3') || e.target.closest('#roketfyReviewsWidget3');
      if (!widget) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;

      if (isMobile) {
        return;
      }

      const targetEl = document.getElementById('roketfyReviewsWidget1');
      if (!targetEl) {
        return;
      }


      const targetTop = targetEl.getBoundingClientRect().top + window.scrollY;
      const startTop = window.scrollY;
      const distance = targetTop - startTop;
      const startTime = performance.now();

      function easeInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      }

      function animateScroll() {
        const elapsed = performance.now() - startTime;
        const progress = Math.min(elapsed / SCROLL_DURATION, 1);
        const eased = easeInOutCubic(progress);
        window.scrollTo(0, startTop + distance * eased);

        if (progress < 1) {
          requestAnimationFrame(animateScroll);
        }
      }

      requestAnimationFrame(animateScroll);
    },
    true
  );
})();

/**
 * SEO: inject Roketfy's rating into the product JSON-LD (client-side).
 *
 * Roketfy renders reviews via AJAX and only merges its aggregateRating into a
 * JSON-LD node whose root is "@type":"Product". Our theme emits a "ProductGroup"
 * node, so Roketfy falls back to injecting its schema into a <noscript> tag
 * (a bug in Roketfy's own code) which Google ignores. We read the rating that
 * Roketfy renders into its widget and add a valid aggregateRating ourselves.
 */
(function () {
  if (!/\/products\//.test(window.location.pathname)) return;

  var injected = false;

  function readRating() {
    var avgEl = document.querySelector(
      '.widget-style-3-average-rating, .widget-style-1-rate-text'
    );
    var countEl = document.querySelector(
      '.widget-style-3-rating-count, .widget-style-1-rating-count'
    );
    if (!avgEl || !countEl) return null;

    var avg = parseFloat((avgEl.textContent || '').replace(',', '.').trim());
    var countMatch = (countEl.textContent || '').match(/\d+/);
    var count = countMatch ? parseInt(countMatch[0], 10) : 0;

    if (!avg || avg <= 0 || !count || count <= 0) return null;
    return { avg: avg, count: count };
  }

  function injectAggregateRating(data) {
    var scripts = document.querySelectorAll('script[type="application/ld+json"]');
    for (var i = 0; i < scripts.length; i++) {
      var json;
      try {
        json = JSON.parse(scripts[i].textContent);
      } catch (e) {
        continue;
      }
      if (!json) continue;

      var type = json['@type'];
      var isProduct =
        type === 'ProductGroup' ||
        type === 'Product' ||
        (Array.isArray(type) &&
          (type.indexOf('ProductGroup') > -1 || type.indexOf('Product') > -1));
      if (!isProduct) continue;

      if (json.aggregateRating) return true; // already present, nothing to do

      json.aggregateRating = {
        '@type': 'AggregateRating',
        ratingValue: data.avg,
        ratingCount: data.count,
        bestRating: '5',
        worstRating: '1'
      };
      scripts[i].textContent = JSON.stringify(json);
      return true;
    }
    return false;
  }

  function tryInject() {
    if (injected) return true;
    var data = readRating();
    if (!data) return false;
    if (injectAggregateRating(data)) {
      injected = true;
      return true;
    }
    return false;
  }

  function start() {
    if (tryInject()) return;

    // Roketfy loads its widget asynchronously; watch the DOM until the rating
    // is rendered, then inject once.
    var observer = new MutationObserver(function () {
      if (tryInject() && observer) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Stop observing after a while regardless of outcome.
    setTimeout(function () {
      try {
        observer.disconnect();
      } catch (e) {}
    }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
